import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { processGoogleSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      // Get session_id from URL hash
      const hash = location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        navigate('/login', { replace: true });
        return;
      }

      const sessionId = sessionIdMatch[1];
      const result = await processGoogleSession(sessionId);

      if (result.success) {
        // Navigate to dashboard with user data
        navigate('/dashboard', { 
          replace: true, 
          state: { user: result.user } 
        });
      } else {
        navigate('/login', { 
          replace: true, 
          state: { error: result.error } 
        });
      }
    };

    processSession();
  }, []);

  return (
    <div className="min-h-screen bg-[#FFFCF5] flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-12 h-12 text-[#C5A059] animate-spin mx-auto mb-4" />
        <p className="text-[#0F172A] font-medium">Completing authentication...</p>
      </div>
    </div>
  );
}
